module.exports = __webpack_public_path__ + "media/images/font/SofiaProLight-dcd9c1217016011040256d674d655275.woff2";